var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-c-c pointer",staticStyle:{"margin-top":"20px","margin-bottom":"30px"},on:{"click":function (){ return _vm.goBack(); }}},[_c('i',{staticClass:"iconfont icon-left",staticStyle:{"font-size":"20px"}}),_vm._v(" "),_c('span',{},[_vm._v(_vm._s(_vm.$t('lang.返回')))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-01f9ae1e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/wenxing/components/returnBackButton.vue
// module id = null
// module chunks = 